import React, {useEffect, useRef} from 'react';
import {Layer, Rect, Transformer} from "react-konva";

const Cropping = ({cropSize, setCropSize, cropSizeRef, imageSize, imageRef, image}) => {
    const transformerRef = useRef(null);

    useEffect(() => {
        setCropSize({
            id: 'cropRect',
            width: cropSizeRef.current?.width ?? imageSize.width,
            height: cropSizeRef.current?.height ?? imageSize.height,
            x: cropSizeRef.current?.x ?? 0,
            y: cropSizeRef.current?.y ?? 0,
        });
    }, []);

    useEffect(() => {
        if (transformerRef.current && imageRef.current) {
            transformerRef.current.nodes([imageRef.current]);
            transformerRef.current.getLayer().batchDraw();
        }
    }, [image]);

    const handleTransformEnd = (e, end = false) => {
        const node = e.target;

        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        if (end) {
            node.scaleX(1);
            node.scaleY(1);
        }

        setCropSize({
            ...cropSize,
            x: node.x(),
            y: node.y(),
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(5, node.height() * scaleY),
        });
    };

    return (
        <Layer>
            <Rect
                width={imageSize.width}
                height={imageSize.height}
                fill={'black'}
                opacity={0.5}
                name={"crop-background"}
                index={999}
            />

            <Rect
                {...cropSize}
                fill={"white"}
                globalCompositeOperation={"destination-out"}
                name={"crop-white-rect"}
                index={9999}
            />

            <Rect
                {...cropSize}
                id={cropSize?.id}
                ref={imageRef}
                draggable
                onDragMove={handleTransformEnd}
                onDragEnd={(e) => handleTransformEnd(e, true)}
                onTransform={handleTransformEnd}
                onTransformEnd={(e) => handleTransformEnd(e, true)}
                name={"crop-rect"}
                index={99999}
            />

            <Transformer
                ref={transformerRef}
                rotateEnabled ={false}
                boundBoxFunc={(oldBox, newBox) => {
                    if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                    }
                    return newBox;
                }}
            />
        </Layer>
    );
};

export default Cropping;